module.exports = __webpack_public_path__ + "img/MHCB.0d627c9d.png";